export default {
    agreement_categories: "Категорії угод",
    app_code: "Код програми-ініціатора",
    authentication_login: "Логин аутентифікації",
    authentication_password: "Пароль аутентифікації",
    cod_no: "Код НО",
    credentials_of_authorized_person: "Авторизація уповноваженої особи",
    director: "Директор",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Чи підтверджуєте відправку посилання на написання відгуку пацієнтові в месенджер?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Підтверджуєте відправку квитанції пацієнту в месенджер?",
    employee_login: "Логин співробітника",
    employee_password: "Пароль співробітника",
    fdoc_instruction: "Для коректної роботи послуги передайте менеджеру FDoc IP-адресу, на яку ви отримуватимете хуки/запити: <code>{ipaddress}</code>. Також назвіть події, які хочете отримувати: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "У розділі персонал у редагуванні співробітника на вкладці FDoc повинні бути вказані логін і пароль співробітника від системи FDoc.",
    files: "Файли",
    files_being_uploaded: "Файли завантажуються. Не закривайте сторінку, поки завантаження не завершиться.",
    fill_questionary: "Заповнити анкету",
    first_new: "Спочатку нові",
    first_old: "Спочатку старі",
    gallery: "Галерея",
    header_in_akt: "Шапка в акті наданих послуг",
    multiple_signers_support: "Підтримка кількох підписантів",
    options: "Опції",
    or_folder_with_dcm_files: "або папку з DCM-файлами",
    select_folder: "Виберіть папку",
    send_receipt_to_messenger: "Відправити квитанцію в месенджер пацієнта",
    sign_selected_via_vendor: "Підписати вибрані через {vendor}",
    table: "Таблиця"
}
